<template>
  <div class="background-color-white full-height rounded-lg">
    <RewardsBeforeAuth v-if="!authorized" />
    <RewardsAfterAuth v-else />
  </div>
</template>

<script>
import RewardsBeforeAuth from "@/components/About/RewardsBeforeAuth.vue";
import RewardsAfterAuth from "@/components/About/RewardsAfterAuth.vue";
import { mapGetters } from "vuex";

export default {
  name: "StoreRewards",
  components: { RewardsBeforeAuth, RewardsAfterAuth },
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
  },
};
</script>
